import { Paper, Stack, Typography } from '@mui/material'
import React from 'react'


const ContentbuyerPurchaserequestDecisionCard = (props) => {
    return (
        <>
            <Paper elevation={0} className={`${props?.type === "approved" ? "cardApprovedSuccess " : props?.type === "pending" ? "cardApprovedPending " : props?.type === "rejected" ? "cardApprovedReject " : ''}decCard`}>
                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'}>
                    <Typography variant='body2'>Decision:</Typography>
                    {
                        props?.type === "approved" ? <>
                            <Typography variant='caption'>Approved</Typography>
                        </> :
                            props?.type === "pending" ? <>
                                <Typography variant='caption'>Pending</Typography>
                            </> :
                                props?.type === "rejected" ? <>
                                    <Typography variant='caption'>Rejected</Typography>
                                </> : null
                    }
                </Stack>
            </Paper>
        </>
    )
}

export default ContentbuyerPurchaserequestDecisionCard